import React, { useState } from 'react';
import courseData from '../../data/courseData';
import CoursesGrid from './CoursesGrid';
import { useSearchParams } from 'react-router-dom';

const Courses = () => {
  const [searchParams,setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState(searchParams?.get('category') || '');

  const filteredCourses = filter
    ? courseData.filter((course) => course.type.toLowerCase() === filter.toLowerCase())
    : courseData;




    const udpateFilterationFn = (val)=>{
      if(val === ""){
         setSearchParams({}); //⚠️ IF WANT TO REMOVE ALL QUERY VALUE 
        return setFilter('');

      }
      else{
        searchParams.set('category', val);
        //window.history.pushState(state, title, url);
         window.history.pushState(null, '', `?${searchParams.toString()}`); ////⚠️ IF WANT TO INTEGRATE TO EXISTING URL 
        return setFilter(val);
      }
    }

  return (
    <div className="container mx-auto px-4 py-10 mt-5">
      <div className="text-center mb-8">
        <h1 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-800">Explore Our Courses</h1>
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => udpateFilterationFn("")}
            className={`px-4 py-2 text-sm rounded-full ${!filter ? "bg-red-600 text-white" : "bg-gray-200 text-gray-700"}`}
          >
            All
          </button>
          <button
            onClick={() => udpateFilterationFn("BBA")}
            className={`px-4 py-2 text-sm rounded-full ${filter === "BBA" ? "bg-red-600 text-white" : "bg-gray-200 text-gray-700"}`}
          >
            BBA
          </button>
          <button
            onClick={() => udpateFilterationFn("MBA")}
            className={`px-4 py-2 text-sm rounded-full ${filter === "MBA" ? "bg-red-600 text-white" : "bg-gray-200 text-gray-700"}`}
          >
            MBA
          </button>
          <button
            onClick={() => udpateFilterationFn("Diploma")}
            className={`px-4 py-2 text-sm rounded-full ${filter === "Diploma" ? "bg-red-600 text-white" : "bg-gray-200 text-gray-700"}`}
          >
            Diploma
          </button>
        </div>
      </div>
      <CoursesGrid courses={filteredCourses} />
    </div>
  );
};

export default Courses;